import { runtimeEnv } from 'config/runtimeEnv';
import requestInstance from './Request';
import { API_ENDPOINT } from './Api';

let env = runtimeEnv('B2B_API_BASE_URL');
// Update Trip API
export const updateTripApi = async (tripId, payload) => {
  try {
    const res = await requestInstance.patch(`${env}/trip-api/v3/edit-trips/${tripId}`, payload);
    return res?.data;
  } catch (err) {
    return err?.response;
  }
};

// Update Trip Pricing/Rate Card API
export const updateTripPricingApi = async (tripId, payload) => {
  try {
    const res = await requestInstance.patch(`${env}/trip-api/v3/reservations/${tripId}`, payload);
    return res?.data;
  } catch (err) {
    return err?.response;
  }
};

export const getTripApi = async (tripId, payload) => {
  try {
    const res = await requestInstance.get(`${env}/trip-api/v1/trips/${tripId}`);
    return res?.data;
  } catch (err) {
    return err?.response;
  }
};

export const updateTripStatusApi = async (data) => {
  try {
    const res = await requestInstance.post(`${env}/trip-api/v3/trip-update-status`, data);
    return res?.data;
  } catch (err) {
    return err?.response;
  }
};

// export const manualTripCloseApi = async (tripId, payload) => {
//   try {
//     const res = await requestInstance.patch(
//       `${env}/trip-api/v3/manual-trip-close/${tripId}`,
//       payload,
//     );
//     return res?.data;
//   } catch (err) {
//     return err?.response;
//   }
// };
